export default "__VITE_ASSET__OormLkcL__"